/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PartnerType;

(function (PartnerType) {
  PartnerType["GENERAL"] = "general";
  PartnerType["BROKER"] = "broker";
})(PartnerType || (PartnerType = {}));